import Icon from '../components/Icon.vue'

Icon.register({
  'sort-alpha-down-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M176 352c14.2 0 21.3 17.3 11.3 27.3l-80 96c-2.6 2.6-7.7 4.7-11.3 4.7-3.7 0-8.7-2.1-11.3-4.7l-80-96c-10.1-10.1-2.9-27.3 11.3-27.3h48v-304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v304h48zM288 224c-8.8 0-16-7.2-16-16v-17.6 0c0-7.9 4.8-18.6 10.7-23.9l61.3-70.5h-56c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v17.6 0c0 7.9-4.8 18.6-10.7 23.9l-61.3 70.5h56c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128zM447.1 458.6c0.5 1.4 0.9 3.9 0.9 5.4 0 8.8-7.2 16-16 16h-24.8 0c-6.4 0-13.2-5-15.2-11.1l-4.4-12.9h-71l-4.4 12.9c-2 6.1-8.8 11.1-15.2 11.1h0-24.8c-8.8 0-16-7.2-16-16 0-1.5 0.4-3.9 0.9-5.4l59.3-160c2.1-5.9 8.8-10.6 15.1-10.6h0 41.4 0c6.2 0 13 4.8 15.1 10.6zM335.6 400h32.8l-16.4-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-alpha-down-alt.js
// module id = 1916
// module chunks = 0